import { auth } from "../firebase";
const endpoint = process.env.REACT_APP_INVITATION_EDITING_URL || "https://us-central1-invitations778.cloudfunctions.net/manageStage5InvitationEditing";
// Page-memory only: a refresh starts a new cache. No edit links or tokens are stored.
const eligibilityChecks = new Map();
const eligibilityKey = (userId, eventId) => JSON.stringify([userId, eventId]);
export async function openInvitationEditor(eventId) {
  if (!auth.currentUser) throw new Error("יש להתחבר מחדש למערכת.");
  const userId = auth.currentUser.uid;
  const response = await fetch(endpoint, { method: "POST", headers: { "Content-Type": "application/json", Authorization: `Bearer ${await auth.currentUser.getIdToken()}` }, body: JSON.stringify({ eventId }) });
  const result = await response.json().catch(() => ({}));
  if (!response.ok) {
    const key = eligibilityKey(userId, eventId);
    if (eligibilityChecks.has(key)) eligibilityChecks.set(key, Promise.resolve(false));
    throw new Error(response.status >= 500 ? "לא ניתן לבדוק את הרשאת עריכת ההזמנה כרגע. נסו שוב." : result.message || "לא ניתן לפתוח את ההזמנה לעריכה. נסו שוב.");
  }
  if (!result.editUrl) throw new Error(result.message || "אין הזמנת מעצב מקושרת הזמינה לעריכה.");
  const url = new URL(result.editUrl);
  if (url.origin !== "https://www.flashback.co.il" || url.username || url.password || url.pathname !== "/he/300-2/" || !url.searchParams.get("fb_edit")) throw new Error("קישור העריכה אינו תקין.");
  // Navigation only; the existing Firebase session still selects and authorizes the event.
  const returnUrl = new URL("/manage?tab=edit&section=file", window.location.origin);
  if (!["https://invitations.flashback.co.il", "https://invitations778.herokuapp.com", "http://localhost:3000"].includes(returnUrl.origin)) throw new Error("כתובת החזרה למערכת אינה תקינה.");
  url.searchParams.set("fb_rsvp_return", returnUrl.toString());
  return url.toString();
}

// WordPress authoritatively checks designer source, paid binding, expiry and remaining edits.
export function getInvitationEditorAvailability(eventId) {
  const userId = auth.currentUser?.uid;
  if (!userId || !eventId) return Promise.resolve(false);
  const key = eligibilityKey(userId, eventId);
  if (!eligibilityChecks.has(key)) {
    const check = openInvitationEditor(eventId)
      .then(() => auth.currentUser?.uid === userId)
      .catch(() => false);
    eligibilityChecks.set(key, check);
  }
  return eligibilityChecks.get(key);
}
